import { Component } from 'react';

export default class BrowserBackLogger extends Component {
  /**
   *
   */
  public componentDidMount() {
    if (
      window.performance?.navigation?.type === window.performance?.navigation?.TYPE_BACK_FORWARD &&
      window.customLogger
    ) {
      // ブラウザバック・ブラウザフォワードの場合はカスタムログを落とす
      window.customLogger.logClick('b_bckfwd', '', '-1');
    }
  }

  /**
   *
   */
  public render() {
    return null;
  }
}
